import React from 'react';
import Contact from './Contact';

const ContactUs = () => {
    return (
        <div>
            <h1>Contact Us</h1>
            <Contact/>
        </div>
    );
};

export default ContactUs;
